import { render, staticRenderFns } from "./ManageStaff.vue?vue&type=template&id=5dd18b1f&"
import script from "./ManageStaff.vue?vue&type=script&lang=js&"
export * from "./ManageStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports